import styles from './style.css'

class AccountSetting extends React.Component {
  render () {
    return (
      <div className={styles['container-full-nosub']} id='account-setting'>
        <div className={`container box-report-child ${styles['container']}`}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default AccountSetting



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/AccountSetting.js